/* Wisecrafted feature tiles — expand/collapse behaviour.
   Desktop (hover-capable): hover opens, leaving closes.
   Touch: tap opens, tapping the same tile or outside closes.
   Only one tile is open at a time. */

(function () {
  function init(grid) {
    if (grid.dataset.wcTilesReady === 'true') return;
    grid.dataset.wcTilesReady = 'true';

    var tiles = Array.prototype.slice.call(grid.querySelectorAll('[data-wc-tile]'));
    if (!tiles.length) return;

    var canHover =
      window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches;

    function close(tile) {
      tile.classList.remove('is-open');
      tile.setAttribute('aria-expanded', 'false');
    }

    function closeAll(except) {
      tiles.forEach(function (tile) {
        if (tile !== except) close(tile);
      });
    }

    function open(tile) {
      closeAll(tile);
      tile.classList.add('is-open');
      tile.setAttribute('aria-expanded', 'true');
    }

    tiles.forEach(function (tile) {
      if (canHover) {
        tile.addEventListener('mouseenter', function () {
          open(tile);
        });
        tile.addEventListener('mouseleave', function () {
          close(tile);
        });
      }

      tile.addEventListener('click', function (event) {
        event.preventDefault();
        // On hover devices a click should never collapse what the pointer
        // is still sitting on; only touch/click-only devices toggle.
        if (canHover) {
          open(tile);
        } else if (tile.classList.contains('is-open')) {
          close(tile);
        } else {
          open(tile);
        }
      });

      tile.addEventListener('focus', function () {
        open(tile);
      });
      tile.addEventListener('blur', function () {
        close(tile);
      });
      tile.addEventListener('keydown', function (event) {
        if (event.key === 'Escape' || event.key === 'Esc') {
          close(tile);
          tile.blur();
        }
      });
    });

    document.addEventListener('click', function (event) {
      if (!grid.contains(event.target)) closeAll(null);
    });
  }

  function initAll(root) {
    (root || document).querySelectorAll('[data-wc-grid]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll();
    });
  } else {
    initAll();
  }

  // Theme editor re-renders sections without a page load.
  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();
